exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".updateCohortstype{\ncolor: black!important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Modules/VMCohortList/vmcohorts.css
// module id = 1580
// module chunks = 0